var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditError = function SvgEditError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-224.000000, -703.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.000000, 703.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#BE1034",
    x: 0,
    y: 0,
    width: 14,
    height: 14,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2266189,8.13491954 L8.85927784,8.13491954 C8.39000351,8.13491954 8.13491954,8.38344111 8.13491954,8.84981739 L8.13491954,11.2266189 C8.13491954,11.6958932 7.75842471,12.0710678 7.2939948,12.0710678 L6.84814083,12.0710678 C6.37783374,12.0710678 6.00721609,11.6929951 6.00721609,11.2266189 L6.00721609,8.84981739 C6.00721609,8.38054307 5.67647309,8.13491954 5.21009682,8.13491954 L2.91551676,8.13491954 C2.44624243,8.13491954 2.07106781,7.75842471 2.07106781,7.2939948 L2.07106781,6.84814083 C2.07106781,6.37783374 2.44914048,6.00721609 2.91551676,6.00721609 L5.21009682,6.00721609 C5.67937114,6.00721609 6.00721609,5.68002423 6.00721609,5.21364796 L6.00721609,2.91551676 C6.00721609,2.44624243 6.38371092,2.07106781 6.84814083,2.07106781 L7.2939948,2.07106781 C7.76430188,2.07106781 8.13491954,2.44914048 8.13491954,2.91551676 L8.13491954,5.21364796 C8.13491954,5.68292228 8.39290156,6.00721609 8.85927784,6.00721609 L11.2266189,6.00721609 C11.6958932,6.00721609 12.0710678,6.38371092 12.0710678,6.84814083 L12.0710678,7.2939948 C12.0710678,7.76430188 11.6929951,8.13491954 11.2266189,8.13491954 Z",
    fill: "#FFFFFF",
    transform: "translate(7.071068, 7.071068) rotate(-315.000000) translate(-7.071068, -7.071068) "
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit_error.31540765.svg";
export { ForwardRef as ReactComponent };